export default __webpack_public_path__ + "static/media/UofT.b8ee0a31.png";